import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PhotographerStats from "./photographer_stats";
import { showToast } from "../../../actions/toast_actions";

const msp = () => ({});

const mdp = (dispatch) => ({
  showToast: (message) => dispatch(showToast(message)),
});

export default withRouter(connect(msp, mdp)(PhotographerStats));